export default __webpack_public_path__ + "static/char-s-39-ko-a6d20f5a12fded6247c5408e1f0ea9f5.png";